<template>
    <ml-layout ref="mlLayout">
        <div class="ml-main">
            <el-card shadow="never">
                <div slot="header" class="clearfix">
                    <span>用户注册</span>
                </div>
                <el-form
                    :model="registerForm"
                    :rules="registerRules"
                    ref="registerForm"
                    label-width="80px"
                    class="registerForm"
                    @validate="registerFormValidate"
                >
                    <el-form-item label="学校" prop="school">
                        <el-select
                            v-model="registerForm.school"
                            filterable
                            remote
                            :remote-method="getRemoteSchoolList"
                            :loading="schoolList.loading"
                            placeholder="请选择学校"
                            class="ml-select"
                        >
                            <el-option
                                v-for="item in schoolList.data"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学号" prop="schoolNumber">
                        <el-input
                            v-model="registerForm.schoolNumber"
                            placeholder="请输入学号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input
                            v-model="registerForm.name"
                            placeholder="请输入姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input
                            show-password
                            v-model="registerForm.password"
                            placeholder="请输入密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPassword">
                        <el-input
                            show-password
                            v-model="registerForm.confirmPassword"
                            placeholder="请再次输入密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input
                            v-model="registerForm.email"
                            :disabled="registerCode.emailDisabled"
                            placeholder="请输入邮箱"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <el-col :span="14">
                            <el-input
                                v-model="registerForm.code"
                                placeholder="请输入验证码"
                                :disabled="registerCode.codeDisabled"
                            ></el-input>
                        </el-col>
                        <el-col :span="10">
                            <el-button
                                type="success"
                                class="ml-float-right"
                                :disabled="registerCode.disabled"
                                :loading="registerCode.loading"
                                @click="handleGetCode"
                            >
                                {{ registerCode.text }}
                            </el-button>
                        </el-col>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="primary"
                            class="ml-submit"
                            :loading="registerButton.loading"
                            @click="submitRegisterForm"
                        >
                            {{ registerButton.text }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </ml-layout>
</template>

<script>
import {
    getSchoolList,
    emailAuth,
    outSchoolRegister
} from "@/api/views/register";

import encrypt from "@/plugins/encrypt";

import MlLayout from "@/components/MlLayout";

export default {
    name: "Register",
    components: {
        MlLayout
    },
    data() {
        // 验证密码函数
        const validatePass = (rule, value, callback) => {
            if (value !== this.registerForm.password) {
                callback(new Error("两次输入密码不一致"));
            } else {
                callback();
            }
        };

        return {
            // 学校列表
            schoolList: {
                data: [],
                loading: false
            },
            // 注册表单
            registerForm: {
                school: "",
                schoolNumber: "",
                name: "",
                password: "",
                confirmPassword: "",
                email: "",
                code: ""
            },
            // 注册表单校验配置
            registerRules: {
                school: [
                    { required: true, message: "请选择学校", trigger: "change" }
                ],
                schoolNumber: [
                    { required: true, message: "请输入学号", trigger: "blur" }
                ],
                name: [
                    { required: true, message: "请输入姓名", trigger: "blur" }
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    { min: 6, message: "密码最短为6位", trigger: "blur" }
                ],
                confirmPassword: [
                    {
                        required: true,
                        message: "请再次输入密码",
                        trigger: "blur"
                    },
                    // 验证两次密码
                    { validator: validatePass, trigger: "blur" }
                ],
                email: [
                    { required: true, message: "请输入邮箱", trigger: "blur" },
                    {
                        type: "email",
                        required: true,
                        message: "请输入正确的邮箱格式",
                        trigger: "change"
                    }
                ],
                code: [
                    { required: true, message: "请输入验证码", trigger: "blur" }
                ]
            },
            // 注册按钮状态
            registerButton: {
                loading: false,
                text: "注册"
            },
            // 获取验证码 状态
            registerCode: {
                disabled: true,
                emailDisabled: false,
                codeDisabled: true,
                text: "获取验证码",
                loading: false
            }
        };
    },
    created() {},
    methods: {
        // 获取学校列表
        getRemoteSchoolList(query) 
        {
            if (query !== "") 
            {
                // ADD BY camellia 2021-11-15 =============================
                // 参数加密
                let params = encrypt({
                    query: query
                });
                // ========================================================
                this.schoolList.loading = true;
                getSchoolList({ params: params }).then(res => {
                    this.schoolList.data = res.schoolList;
                    this.schoolList.loading = false;
                });
            } 
            else 
            {
                this.schoolList.data = [];
            }
        },
        // 每次校验之后会激活这个函数
        registerFormValidate(name, status) {
            // 邮箱验证成功，取消获取验证码的禁用
            if (name === "email" && this.registerCode.text === "获取验证码") {
                this.registerCode.disabled = !status;
                this.registerCode.codeDisabled = !status;
            }
        },
        // 注册
        submitRegisterForm() {
            this.$refs.registerForm.validate().then(() => {
                this.registerButton = {
                    loading: true,
                    text: "请求中"
                };
                outSchoolRegister({
                    personal_id: this.registerForm.schoolNumber,
                    name: this.registerForm.name,
                    pwd: this.registerForm.password,
                    email: this.registerForm.email,
                    school_id: this.registerForm.school,
                    code: this.registerForm.code
                })
                    .then(res => {
                        this.$message.success("注册成功");
                        this.$refs.mlLayout.updateUserInfo(res.userinfo);
                        this.$router.push("/");
                    })
                    .finally(() => {
                        this.registerButton = {
                            loading: false,
                            text: "注册"
                        };
                    });
            });
        },
        // 获取验证码
        handleGetCode() {
            this.registerCode = {
                disabled: true,
                emailDisabled: true,
                codeDisabled: false,
                text: "发送中",
                loading: true
            };

            emailAuth({ email: this.registerForm.email })
                .then(() => {
                    this.$message.success("发送成功");
                    let maxTime = 60;
                    this.registerCode.text = "60秒后发送";
                    this.registerCode.loading = false;
                    const timer = setInterval(() => {
                        maxTime--;
                        this.registerCode.text = maxTime + "秒后重新发送";
                        if (maxTime <= 0) {
                            clearInterval(timer);
                            this.registerCode.text = "获取验证码";
                            this.registerCode.disabled = false;
                            this.registerCode.emailDisabled = false;
                        }
                    }, 1000);
                })
                .catch(() => {
                    this.registerCode = {
                        disabled: false,
                        emailDisabled: false,
                        text: "获取验证码",
                        loading: false
                    };
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.registerForm {
    width: 40%;
    margin: 0 auto;
}
</style>
